'use client';

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider } from 'next-themes';
import { PropsWithChildren } from 'react';
import { TooltipProvider } from '@repo/ui/components';
import { Toaster } from '../components/ui/sonner.tsx';
export const UIProvider = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["system", "light", "dark"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Toaster data-sentry-element="Toaster" data-sentry-source-file="provider.tsx" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <ThemeProvider attribute="class" defaultTheme="system" disableTransitionOnChange={true} enableSystem={true} themes={t1} data-sentry-element="ThemeProvider" data-sentry-component="UIProvider" data-sentry-source-file="provider.tsx"><TooltipProvider data-sentry-element="TooltipProvider" data-sentry-source-file="provider.tsx">{t2}{children}</TooltipProvider></ThemeProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export { useTheme } from 'next-themes';